import React, { FunctionComponent } from 'react';
import styles from './latest-case-studies.module.scss';
import {
  CaseStudyListItem,
  ICaseStudyItem
} from '../case-study-list/case-study-list-item/case-study-article-list-item';
import { useLatestCaseStudies } from '../../hooks/use-latest-case-studies';
import { Text, ITextProps } from '../text/text';
import { Button, IButtonProps } from '../button/button';

export interface ILatestCaseStudiesProps {
  header: ITextProps | null;
  seeMoreButton: IButtonProps;
}

const LatestCaseStudiesComponent: FunctionComponent<ILatestCaseStudiesProps> = ({
  header,
  seeMoreButton
}) => {
  const caseStudies = useLatestCaseStudies();

  return (
    <div className={styles.container}>
      {header && (
        <div className={styles.header}>
          <Text {...header} />
        </div>
      )}
      <div className={styles.articlesWrapper}>
        {caseStudies.map((article: ICaseStudyItem, i) => (
          <CaseStudyListItem data={article} key={i} />
        ))}
      </div>
      <div className={styles.seeMoreButton}>
        <Button {...seeMoreButton} />
      </div>
    </div>
  );
};

export const LatestCaseStudies = React.memo(LatestCaseStudiesComponent);
